import React, { useContext, useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import TosterService from "../../../../Services/Toster-Service/TosterService";
import { getWFHDetails, postWFHStatusData } from "./WfhSerevice";
import { TostMsg } from "../../../../App";
import { LoaderContext } from "../../../../Services/Loader_Provider_Service/LoadingContext";
import WfhNavBarItems from "./WfhCommon/WfhNavBarItems";
import ERROR_LIST from "../../../../Services/Global-Services/Hadle_Errors";
import moment from "moment";

function MyWfhCompleted() {
  const toster = useContext(TostMsg);
  const [completedWFHData, setCompletedWFHData] = useState([]);
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  const [showAllUserDataInModel, setshowAllUserDataInModel] = useState([]);
  const [resonValue, setResonValue] = useState("");
  const { showLoading, hideLoading } = useContext(LoaderContext);
  useEffect(() => {
    getCompleteWFHData();
  }, []);

  const ResontextStyle = {
    maxWidth: "100%",
    display: "-webkit-box",
    WebkitBoxOrient: "vertical",
    WebkitLineClamp: 3,
    overflow: "hidden",
    textOverflow: "ellipsis",
    cursor: "pointer",
  };

  async function getCompleteWFHData() {
    showLoading();
    const param = {
      OrgId: userDetails?.OrgId,
      LoggedInUserId: userDetails?.EmpId,
      WFHid: 0,
      EmpId: userDetails?.EmpId,
    };
    try {
      let projectDetailData = await getWFHDetails(param);
      setCompletedWFHData(projectDetailData?.Data);
      hideLoading();
    } catch {
      hideLoading();
    }
  }

  const handleResonChange = (e) => {
    setResonValue(e.target.value);
  };

  const handleWithdrwalSubmit = async (submitType) => {
    if (submitType == "Withdrwal") {
      showLoading();
      const body = {
        id: showAllUserDataInModel?.Id ?? 0,
        OrgId: userDetails?.OrgId,
        EmpId: userDetails?.EmpId,
        WFHStatusId: 102,
        Reason: resonValue ?? "",
      };

      try {
        let awardList = await postWFHStatusData(body);
        if (awardList) {
          getCompleteWFHData();
          toster.current.success("WFH status updated successfully");
          hideLoading();
        }
      } catch (error) {
        toster.current.error(ERROR_LIST.DefaultError);
        hideLoading();
      }
    }
  };

  return (
    <div>
      <div id="circular-menu" className="circular-menu">
        <a className="floating-btn">
          <i aria-hidden="true" className="fa fa-cog fa-spin"></i>
          <i aria-hidden="true" className="fa fa-times"></i>
        </a>
        <div className="items-wrapper">
          <div className="menu-item is-flex">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </div>
          <a
            className="menu-item is-flex right-panel-trigger"
            data-panel="languages-panel"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </a>
          <Link to="" className="menu-item is-flex">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </Link>
          <a
            className="menu-item is-flex right-panel-trigger"
            data-panel="activity-panel"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-grid"
            >
              <rect x="3" y="3" width="7" height="7"></rect>
              <rect x="14" y="3" width="7" height="7"></rect>
              <rect x="14" y="14" width="7" height="7"></rect>
              <rect x="3" y="14" width="7" height="7"></rect>
            </svg>
          </a>
        </div>
      </div>
      <div className="container-fluid">
        <div className="row">
          <div className="form-head d-flex flex-wrap align-items-center">
            <div className="me-auto">
              <h2 className="font-w600 mb-0">My WFH</h2>
              <p className="text-light">Lorem ipsum dolor sit amet</p>
            </div>
            <div className="rightside-tabs">
              <WfhNavBarItems />
            </div>
          </div>

          <div className="col-xl-8">
            <div className="leave-card tile-grid tile-grid-v1">
              <div className="card">
                <div className="tab-tabsa">
                  <div className="me-auto">
                    <Link to="MyWfh">
                      <h2 className="font-w600 mb-0">Upcoming Leave</h2>
                    </Link>
                  </div>
                  <div className="me-auto">
                    <Link to="MyWfhCompleted">
                      <h2 className="font-w600 mb-0 h2active">
                        Completed Leave
                      </h2>
                    </Link>
                  </div>
                  <div className="me-auto">
                    <Link to="MyPendingWfh">
                      <h2 className="font-w600 mb-0">Pending Leave</h2>
                    </Link>
                  </div>
                  <div className="me-auto side-filter">
                    <Link to="">
                      <img src="images/org-img/leave/filter.svg" />
                    </Link>
                  </div>
                </div>
              </div>
              {completedWFHData.map((wfhData, index) => {
                return (
                  <div className="card bottom-card" key={index}>
                    <div className="card-body pb-0">
                      <div className="row">
                        <div className="col-xl-2">
                          <img
                            src="images/org-img/leave/upcoming.png"
                            className="w-100"
                          />
                        </div>
                        <div className="col-xl-4 p-3">
                          <div className="media-body px-0">
                            <h4 className="mt-0 mb-0 fss-17">
                              <a
                                className="text-black"
                                style={ResontextStyle}
                                title={wfhData?.Reason}
                              >
                                {wfhData?.Reason}.
                              </a>
                            </h4>
                            <span className="mt-0 mb-3 fs-14 datecol">
                              {wfhData?.LeaveStatusName}
                            </span>
                          </div>
                        </div>
                        <div className="col-xl-3 p-3">
                          <p className="m-0">
                            <b>From </b>:
                            {moment(wfhData?.StartDate).format("MMM DD YYYY")}
                          </p>
                          <p className="m-0">
                            <b>To </b>:
                            {moment(wfhData?.EndDate).format("MMM DD YYYY")}
                          </p>
                          <p className="m-0">
                            <b>Half Day </b>:
                            {wfhData.IsHalfDay == false && <span>No</span>}{" "}
                            {wfhData.IsHalfDay == true && <span>Yes</span>}
                          </p>
                        </div>
                        <div className="col-xl-3 p-3">
                          <p className="m-0">
                            <b>Action on </b>:16-11-22
                          </p>
                          <p className="m-0">
                            <b>Action By </b>: Arun Mishra
                          </p>

                          {wfhData?.WFHStatusId === 103 && (
                            <p className="status-p">
                              <a>
                                <i
                                  className="fa fa-check-square-o"
                                  aria-hidden="true"
                                ></i>{" "}
                                {wfhData?.LeaveStatusName}
                              </a>
                            </p>
                          )}
                          {wfhData?.WFHStatusId === 103 && (
                            <p className="status-p11">
                              <a
                                data-bs-toggle="modal"
                                data-bs-target="#pending-request"
                                onClick={() => {
                                  setshowAllUserDataInModel(wfhData);
                                }}
                              >
                                <i
                                  className="fa fa-check-square-o"
                                  aria-hidden="true"
                                ></i>{" "}
                                Withdrwal
                              </a>
                            </p>
                          )}
                          {wfhData?.WFHStatusId != 103 && (
                            <p className="status-p1">
                              <a>
                                <i
                                  className="fa fa-check-square-o"
                                  aria-hidden="true"
                                ></i>{" "}
                                {wfhData?.LeaveStatusName}
                              </a>
                            </p>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
          <div className="col-xl-4">
            <div className="row sidecarddd">
              <div className="col-xl-12">
                <div className="">
                  <div className="card-body contact-mandiv">
                    <a className="reporting-manager">
                      <h6>
                        Remind your reporting manager For any leave
                        clarifications.
                      </h6>
                      <div>
                        <img src="images/avatar/1.jpg" />
                        <strong>Aman Verma</strong>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-xl-12">
                <div className="card">
                  <div className="card-body upcomingdiv">
                    <div className="d-flex" style={{ padding: "4%" }}>
                      <h4 className="text-primary sideh432">Title</h4>
                      <ul
                        className="nav nav-tabs ml-auto"
                        style={{ marginLeft: "auto" }}
                      >
                        <li className="nav-item">
                          <a
                            className="nav-link active"
                            data-bs-toggle="tab"
                            href="#home"
                          >
                            Mine
                          </a>
                        </li>
                        <li className="nav-item">
                          <a
                            className="nav-link"
                            data-bs-toggle="tab"
                            href="#menu1"
                          >
                            Direct Reports
                          </a>
                        </li>
                        <li className="nav-item">
                          <a
                            className="nav-link"
                            data-bs-toggle="tab"
                            href="#menu2"
                          >
                            My Hierarchy
                          </a>
                        </li>
                      </ul>
                    </div>
                    <div className="tab-content">
                      <div
                        className="tab-pane container active mt-0 p-3"
                        id="home"
                      >
                        <div className="media mb-2 align-items-center event-list">
                          <div className="p-2 text-center me-3 date-bx">
                            <img
                              src="images/org-img/leave/check.png"
                              className="w-100"
                            />
                          </div>
                          <div className="media-body px-0">
                            <h6 className="mt-0 mb-0 fss-14">
                              <a className="text-black" href="event.html">
                                Finish document review
                              </a>
                            </h6>
                            <span className="mt-0 mb-3 fs-14 datecol">
                              at 20-2-22
                            </span>
                          </div>
                          <a href="index" className="common-status-color">
                            <i className="fa fa-clock-o" aria-hidden="true"></i>
                            Pending
                          </a>
                        </div>
                        <div className="media mb-2 align-items-center event-list">
                          <div className="p-2 text-center me-3 date-bx">
                            <img
                              src="images/org-img/leave/check.png"
                              className="w-100"
                            />
                          </div>
                          <div className="media-body px-0">
                            <h6 className="mt-0 mb-0 fss-14">
                              <a className="text-black" href="event.html">
                                Fell sick
                              </a>
                            </h6>
                            <span className="mt-0 mb-3 fs-14 datecol">
                              at 20-2-22
                            </span>
                          </div>
                          <a href="index" className="common-status-color">
                            <i className="fa fa-clock-o" aria-hidden="true"></i>
                            Pending
                          </a>
                        </div>
                        <div className="media mb-2 align-items-center event-list">
                          <div className="p-2 text-center me-3 date-bx">
                            <img
                              src="images/org-img/leave/check.png"
                              className="w-100"
                            />
                          </div>
                          <div className="media-body px-0">
                            <h6 className="mt-0 mb-0 fss-14">
                              <a className="text-black" href="event.html">
                                Family Function
                              </a>
                            </h6>
                            <span className="mt-0 mb-3 fs-14 datecol">
                              at 20-2-22
                            </span>
                          </div>
                        </div>
                        <div className="media mb-2 align-items-center event-list">
                          <div className="p-2 text-center me-3 date-bx">
                            <img
                              src="images/org-img/leave/check.png"
                              className="w-100"
                            />
                          </div>
                          <div className="media-body px-0">
                            <h6 className="mt-0 mb-0 fss-14">
                              <a className="text-black" href="event.html">
                                Family Function
                              </a>
                            </h6>
                            <span className="mt-0 mb-3 fs-14 datecol">
                              at 20-2-22
                            </span>
                          </div>
                        </div>
                        <div className="media mb-2 align-items-center event-list">
                          <div className="p-2 text-center me-3 date-bx">
                            <img
                              src="images/org-img/leave/check.png"
                              className="w-100"
                            />
                          </div>
                          <div className="media-body px-0">
                            <h6 className="mt-0 mb-0 fss-14">
                              <a className="text-black" href="event.html">
                                Family Function
                              </a>
                            </h6>
                            <span className="mt-0 mb-3 fs-14 datecol">
                              at 20-2-22
                            </span>
                          </div>
                        </div>
                        <div className="media mb-2 align-items-center event-list">
                          <div className="p-2 text-center me-3 date-bx">
                            <img
                              src="images/org-img/leave/check.png"
                              className="w-100"
                            />
                          </div>
                          <div className="media-body px-0">
                            <h6 className="mt-0 mb-0 fss-14">
                              <a className="text-black" href="event.html">
                                Family Function
                              </a>
                            </h6>
                            <span className="mt-0 mb-3 fs-14 datecol">
                              at 20-2-22
                            </span>
                          </div>
                        </div>

                        <Link
                          to="MyLeave"
                          className="text-center d-block"
                          style={{ fontSize: "14px", color: "#a0a0a0" }}
                        >
                          Load more
                        </Link>
                      </div>

                      <div
                        className="tab-pane container fade mt-0 p-3"
                        id="menu1"
                      >
                        <div className="media mb-2 align-items-center event-list">
                          <div className="h-avatar is-medium">
                            <img
                              className="avatar"
                              src="images/avatar/1.jpg"
                              data-demo-src="images/avatar/1.jpg"
                              alt=""
                              data-user-popover="25"
                              data-target="webuiPopover6"
                            />
                          </div>
                          <div className="media-body p-3">
                            <h6 className="mt-0 mb-0 fss-14">
                              <a className="text-black" href="event.html">
                                Karan Rana
                              </a>
                            </h6>
                            <span className="mt-0 mb-3 fs-14 datecol">
                              Reason : Lorem ipsum
                            </span>
                          </div>
                          <Link to="" className="common-status-color">
                            View detail
                          </Link>
                        </div>
                        <div className="media mb-2 align-items-center event-list">
                          <div className="h-avatar is-medium">
                            <img
                              className="avatar"
                              src="images/avatar/2.jpg"
                              data-demo-src="images/avatar/1.jpg"
                              alt=""
                              data-user-popover="25"
                              data-target="webuiPopover6"
                            />
                          </div>
                          <div className="media-body p-3">
                            <h6 className="mt-0 mb-0 fss-14">
                              <a className="text-black" href="event.html">
                                Geeta Verma
                              </a>
                            </h6>
                            <span className="mt-0 mb-3 fs-14 datecol">
                              Reason : Lorem ipsum
                            </span>
                          </div>
                          <Link to="" className="common-status-color">
                            View detail
                          </Link>
                        </div>
                        <div className="media mb-2 align-items-center event-list">
                          <div className="h-avatar is-medium">
                            <img
                              className="avatar"
                              src="images/avatar/3.jpg"
                              data-demo-src="images/avatar/1.jpg"
                              alt=""
                              data-user-popover="25"
                              data-target="webuiPopover6"
                            />
                          </div>
                          <div className="media-body p-3">
                            <h6 className="mt-0 mb-0 fss-14">
                              <a className="text-black" href="event.html">
                                Savita Rana
                              </a>
                            </h6>
                            <span className="mt-0 mb-3 fs-14 datecol">
                              Reason : Lorem ipsum
                            </span>
                          </div>
                          <Link to="" className="common-status-color">
                            View detail
                          </Link>
                        </div>
                        <Link
                          to="MyLeave"
                          className="text-center d-block"
                          style={{ fontSize: "14px", color: "#a0a0a0" }}
                        >
                          Load more
                        </Link>
                      </div>
                      <div
                        className="tab-pane container fade mt-0 p-3"
                        id="menu2"
                      >
                        <div className="media mb-2 align-items-center event-list">
                          <div className="h-avatar is-medium">
                            <img
                              className="avatar"
                              src="images/avatar/4.jpg"
                              data-demo-src="images/avatar/1.jpg"
                              alt=""
                              data-user-popover="25"
                              data-target="webuiPopover6"
                            />
                          </div>
                          <div className="media-body p-3">
                            <h6 className="mt-0 mb-0 fss-14">
                              <a className="text-black" href="event.html">
                                Shweta Sharma
                              </a>
                            </h6>
                            <span className="mt-0 mb-3 fs-14 datecol">
                              Reason : Lorem ipsum
                            </span>
                          </div>
                          <Link to="" className="common-status-color">
                            View detail
                          </Link>
                        </div>
                        <div className="media mb-2 align-items-center event-list">
                          <div className="h-avatar is-medium">
                            <img
                              className="avatar"
                              src="images/avatar/5.jpg"
                              data-demo-src="images/avatar/1.jpg"
                              alt=""
                              data-user-popover="25"
                              data-target="webuiPopover6"
                            />
                          </div>
                          <div className="media-body p-3">
                            <h6 className="mt-0 mb-0 fss-14">
                              <a className="text-black" href="event.html">
                                Sumit Sahu
                              </a>
                            </h6>
                            <span className="mt-0 mb-3 fs-14 datecol">
                              Reason : Lorem ipsum
                            </span>
                          </div>
                          <Link to="" className="common-status-color">
                            View detail
                          </Link>
                        </div>
                        <div className="media mb-2 align-items-center event-list">
                          <div className="h-avatar is-medium">
                            <img
                              className="avatar"
                              src="images/avatar/6.jpg"
                              data-demo-src="images/avatar/1.jpg"
                              alt=""
                              data-user-popover="25"
                              data-target="webuiPopover6"
                            />
                          </div>
                          <div className="media-body p-3">
                            <h6 className="mt-0 mb-0 fss-14">
                              <a className="text-black" href="event.html">
                                Sonal Singh
                              </a>
                            </h6>
                            <span className="mt-0 mb-3 fs-14 datecol">
                              Reason : Lorem ipsum
                            </span>
                          </div>
                          <Link to="" className="common-status-color">
                            View detail
                          </Link>
                        </div>
                        <div className="media mb-2 align-items-center event-list">
                          <div className="h-avatar is-medium">
                            <img
                              className="avatar"
                              src="images/avatar/7.jpg"
                              data-demo-src="images/avatar/1.jpg"
                              alt=""
                              data-user-popover="25"
                              data-target="webuiPopover6"
                            />
                          </div>
                          <div className="media-body p-3">
                            <h6 className="mt-0 mb-0 fss-14">
                              <a className="text-black" href="event.html">
                                Deepak Verma
                              </a>
                            </h6>
                            <span className="mt-0 mb-3 fs-14 datecol">
                              Reason : Lorem ipsum
                            </span>
                          </div>
                          <Link to="" className="common-status-color">
                            View detail
                          </Link>
                        </div>
                        <Link
                          to="MyLeave"
                          className="text-center d-block"
                          style={{ fontSize: "14px", color: "#a0a0a0" }}
                        >
                          Load more
                        </Link>
                      </div>
                    </div>
                    <div className="card-body pb-0"></div>
                  </div>
                </div>
              </div>

              <div className="col-xl-12">
                <div
                  className="leave-ad-design"
                  data-background="assets/img/illustrations/cards/birthday-bg.svg"
                >
                  <div className="card-body">
                    <div>
                      <div className="birthday-avatar text-center">
                        <svg viewBox="0 0 160 90" fill="none" xmlns="http://www.w3.org/2000/svg" width="160" height="90">
  <rect x="20" y="40" width="30" height="44" rx="4" fill="#671cc9" opacity=".85"></rect>
  <rect x="22" y="42" width="26" height="2" rx="1" fill="#fff" opacity=".4"></rect>
  <rect x="22" y="47" width="20" height="2" rx="1" fill="#fff" opacity=".3"></rect>

  <rect x="52" y="30" width="30" height="54" rx="4" fill="#ec4119" opacity=".85"></rect>
  <rect x="54" y="32" width="26" height="2" rx="1" fill="#fff" opacity=".4"></rect>
  <rect x="54" y="37" width="18" height="2" rx="1" fill="#fff" opacity=".3"></rect>

  <rect x="84" y="20" width="30" height="64" rx="4" fill="#26a69a" opacity=".85"></rect>
  <rect x="86" y="22" width="26" height="2" rx="1" fill="#fff" opacity=".4"></rect>
  <rect x="86" y="27" width="22" height="2" rx="1" fill="#fff" opacity=".3"></rect>

  <circle cx="132" cy="42" r="12" fill="#f7c5a8"></circle>
  <path d="M126 38 Q128 32 132 32 Q136 32 138 38" fill="#2d1a0e"></path>
  <circle cx="129" cy="42" r="1.5" fill="#2d1a0e"></circle>
  <circle cx="135" cy="42" r="1.5" fill="#2d1a0e"></circle>
  <path d="M129 47 Q132 50 135 47" stroke="#2d1a0e" stroke-width="1" stroke-linecap="round" fill="none"></path>

  <rect x="122" y="54" width="20" height="24" rx="8" fill="#671cc9"></rect>
  <path d="M122 78 Q114 82 108 78" stroke="#f7c5a8" stroke-width="6" stroke-linecap="round"></path>
  <path d="M142 78 Q150 82 152 76" stroke="#f7c5a8" stroke-width="6" stroke-linecap="round"></path>

  <rect x="108" y="62" width="18" height="13" rx="3" fill="#ec4119" opacity=".9"></rect>
  <rect x="110" y="64" width="14" height="1.5" rx=".75" fill="#fff" opacity=".6"></rect>
  <rect x="110" y="68" width="10" height="1.5" rx=".75" fill="#fff" opacity=".4"></rect>

  <text x="96" y="18" font-size="10" fill="#ec4119" opacity=".8">✦</text>
  <text x="148" y="28" font-size="8" fill="#671cc9" opacity=".7">✦</text>
  <text x="12" y="36" font-size="7" fill="#26a69a" opacity=".7">✦</text>
</svg>
                      </div>
                      <div className="birthday-content">
                        <h4
                          style={{
                            color: "white",
                            fontSize: "24px",
                            margin: "0",
                          }}
                        >
                          Review our employee leave policy
                        </h4>

                        <Link
                          to="PolicyList"
                          type="button"
                          className="button light-button"
                        >
                          View
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="modal fade" id="contact-manager">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title m-auto">
                Contact Your Reporting Manager htmlFor Any Leave Clarifications
              </h5>
            </div>
            <div className="modal-body text-center">
              <form>
                <div className="form-group text-left">
                  <label>Repoting Manager</label>
                  <select className="default-select form-control wide mb-3">
                    <option selected disabled>
                      Select reporting manager
                    </option>
                    <option>Arun Mishra</option>
                    <option>Pragya Tiwari</option>
                    <option>Alisha Goyal</option>
                  </select>
                </div>
                <div className="form-group text-left">
                  <label className="mt-3">Reason</label>
                  <textarea
                    rows="4"
                    cols="1"
                    className="form-control"
                  ></textarea>
                </div>
              </form>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-danger light"
                data-bs-dismiss="modal"
              >
                Decline
              </button>
              <button type="button" className="btn btn-primary">
                Accept
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="modal fade" id="pending-request">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title m-auto">withdrawal Request</h5>
            </div>
            <form onSubmit={handleWithdrwalSubmit}>
              <div className="modal-body text-center">
                <div className="h-avatar">
                  <img
                    className="avatar"
                    src={userDetails?.ProfileImage}
                    alt="Avatar"
                  />
                </div>
                <p className="name-p">{showAllUserDataInModel?.EmployeeName}</p>
                <p className="des-p">{showAllUserDataInModel?.Reason}.</p>
                <div
                  className="d-flex set-p"
                  style={{ showAllUserDataInModel: "center" }}
                >
                  <p className="me-4">
                    <b>From </b>:
                    {moment(showAllUserDataInModel?.StartDate).format(
                      "MMM DD YYYY"
                    )}
                  </p>
                  <p className="me-4">
                    <b>To </b>:
                    {moment(showAllUserDataInModel?.EndDate).format(
                      "MMM DD YYYY"
                    )}
                  </p>
                  <p className="me-4">
                    <b>Half Day </b>:
                    {showAllUserDataInModel.IsHalfDay == false && (
                      <span>No</span>
                    )}{" "}
                    {showAllUserDataInModel.IsHalfDay == true && (
                      <span>Yes</span>
                    )}
                  </p>
                </div>
                <label className="mt-3">Reason</label>
                <textarea
                  rows="4"
                  cols="1"
                  className="form-control"
                  value={resonValue}
                  onChange={handleResonChange}
                ></textarea>
              </div>
            </form>
            <div className="modal-footer m-auto">
              <button
                type="button"
                className="btn btn-danger light"
                data-bs-dismiss="modal"
              >
                cancel
              </button>
              <button
                type="button"
                onClick={() => handleWithdrwalSubmit("Withdrwal")}
                className="btn btn-primary"
              >
                Accept
              </button>
            </div>
          </div>
        </div>
      </div>

      <TosterService ref={toster} />
    </div>
  );
}

export default MyWfhCompleted;
